import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'automationGridCardName',
})
export class AutomationGridCardNameDirective implements PipeTransform {
  transform(name: string): string {
    switch (name) {
      case `Send document to sign when inquiry created`:
        return $localize`Send document to sign when inquiry created`
      case `Send it to Zapier when booking created`:
        return $localize`Send it to Zapier when booking created`
      case `Mark booking as paid when booking confirmed`:
        return $localize`Mark booking as paid when booking confirmed`
      case `Send document to sign when booking confirmed`:
        return $localize`Send document to sign when booking confirmed`
      case `Send it to Zapier when booking confirmed`:
        return $localize`Send it to Zapier when booking confirmed`
      case `Send it to Zapier when booking canceled`:
        return $localize`Send it to Zapier when booking canceled`
      case `Create task and assign to user when dates are updated`:
        return $localize`Create task and assign to user when dates are updated`
      case `Remove all existing tasks for this booking when dates are updated`:
        return $localize`Remove all existing tasks for this booking when dates are updated`
      case `Send it to Zapier when booking dates are updated`:
        return $localize`Send it to Zapier when booking dates are updated`
      case `Notify the guest of the rental change when rental is updated`:
        return $localize`Notify the guest of the rental change when rental is updated`
      case `Notify user(s) of the rental change when rental is updated`:
        return $localize`Notify user(s) of the rental change when rental is updated`
      case `Create task and assign to user when rental is updated`:
        return $localize`Create task and assign to user when rental is updated`
      case `Remove all existing tasks for this booking when rental is updated`:
        return $localize`Remove all existing tasks for this booking when rental is updated`
      case `Send it to Zapier when booking rental is updated`:
        return $localize`Send it to Zapier when booking rental is updated`
      case `Notify the new guest of the booking when guest is updated`:
        return $localize`Notify the new guest of the booking when guest is updated`
      case `Notify user(s) of the new guest when guest is updated`:
        return $localize`Notify user(s) of the new guest when guest is updated`
      case `Send it to Zapier when booking guest is updated`:
        return $localize`Send it to Zapier when booking guest is updated`
      case `Notify the guest of change when cost is updated`:
        return $localize`Notify the guest of change when cost is updated`
      case `Send it to Zapier when booking cost is updated`:
        return $localize`Send it to Zapier when booking cost is updated`
      case `Notify the guest of payment receipt when booking is paid`:
        return $localize`Notify the guest of payment receipt when booking is paid`
      case `Notify user(s) of booking when booking is paid`:
        return $localize`Notify user(s) of booking when booking is paid`
      case `Create task and assign to user when booking is paid`:
        return $localize`Create task and assign to user when booking is paid`
      case `Send it to Zapier when booking is paid`:
        return $localize`Send it to Zapier when booking is paid`
      case `Send guest portal link before check-in`:
        return $localize`Send guest portal link before check-in`
      case `Send document to sign before check-in`:
        return $localize`Send document to sign before check-in`
      case `Send it to Zapier before check-in`:
        return $localize`Send it to Zapier before check-in`
      case `Send document to sign after check-in`:
        return $localize`Send document to sign after check-in`
      case `Send it to Zapier after check-in`:
        return $localize`Send it to Zapier after check-in`
      case `Send document to sign before check-out`:
        return $localize`Send document to sign before check-out`
      case `Send it to Zapier before check-out`:
        return $localize`Send it to Zapier before check-out`
      case `Send review to Guest after checkout`:
        return $localize`Send review to Guest after checkout`
      case `Set the rental status to Not Ready after checkout`:
        return $localize`Set the rental status to Not Ready after checkout`
      case `Send it to Zapier after check-out`:
        return $localize`Send it to Zapier after check-out`
      case `Send document to sign after check-out`:
        return $localize`Send document to sign after check-out`
      case `Confirm the booking when card accepted`:
        return $localize`Confirm the booking when card accepted`
      case `Notify the guest of card accepted`:
        return $localize`Notify the guest of card accepted`
      case `Notify the user(s) of card accepted`:
        return $localize`Notify the user(s) of card accepted`
      case `Mark booking for follow-up when card declined`:
        return $localize`Mark booking for follow-up when card declined`
      case `Mark booking as unpaid when card declined`:
        return $localize`Mark booking as unpaid when card declined`
      case `Notify the user(s) of card declined`:
        return $localize`Notify the user(s) of card declined`
      case `Mark booking for follow-up when card rejected`:
        return $localize`Mark booking for follow-up when card rejected`
      case `Mark booking as unpaid when card rejected`:
        return $localize`Mark booking as unpaid when card rejected`
      case `Notify the user(s) of card rejected`:
        return $localize`Notify the user(s) of card rejected`
      case `Mark booking for follow-up when card deleted`:
        return $localize`Mark booking for follow-up when card deleted`
      case `Notify the user(s) of card deleted`:
        return $localize`Notify the user(s) of card deleted`
      case `Notify the guest of charge creation`:
        return $localize`Notify the guest of charge creation`
      case `Notify the user(s) of charge creation`:
        return $localize`Notify the user(s) of charge creation`
      case `Mark booking as paid when charge paid`:
        return $localize`Mark booking as paid when charge paid`
      case `Notify the guest of successful charge`:
        return $localize`Notify the guest of successful charge`
      case `Notify the guest of failed charge`:
        return $localize`Notify the guest of failed charge`
      case `Notify the user(s) of failed charge`:
        return $localize`Notify the user(s) of failed charge`
      case `Mark the booking status for followup when charge failed`:
        return $localize`Mark the booking status for followup when charge failed`
      case `Notify the guest when charge deleted`:
        return $localize`Notify the guest when charge deleted`
      case `Notify the user(s) when charge deleted`:
        return $localize`Notify the user(s) when charge deleted`
      case `Notify the guest of the expense`:
        return $localize`Notify the guest of the expense`
      case `Notify the user(s) of the expense`:
        return $localize`Notify the user(s) of the expense`
      case `Send it to Zapier when expense created`:
        return $localize`Send it to Zapier when expense created`
      case `Mark the expense as paid when expense approved`:
        return $localize`Mark the expense as paid when expense approved`
      case `Notify the user(s) of expense approved`:
        return $localize`Notify the user(s) of expense approved`
      case `Send it to Zapier when expense approved`:
        return $localize`Send it to Zapier when expense approved`
      case `Mark the expense as unpaid when expense denied`:
        return $localize`Mark the expense as unpaid when expense denied`
      case `Notify the user(s) of expense denied`:
        return $localize`Notify the user(s) of expense denied`
      case `Send it to Zapier when expense denied`:
        return $localize`Send it to Zapier when expense denied`
      case `Notify the user(s) of expense deleted`:
        return $localize`Notify the user(s) of expense deleted`
      case `Send it to Zapier when expense deleted`:
        return $localize`Send it to Zapier when expense deleted`
      case `Notify the guest of the extra created`:
        return $localize`Notify the guest of the extra created`
      case `Notify the user(s) of extra created`:
        return $localize`Notify the user(s) of extra created`
      case `Notify the user(s) of extra paid`:
        return $localize`Notify the user(s) of extra paid`
      case `Notify the user(s) of extra deleted`:
        return $localize`Notify the user(s) of extra deleted`
      case `Set the rental status to Not Ready when incident created`:
        return $localize`Set the rental status to Not Ready when incident created`
      case `Notify the guest of the incident created`:
        return $localize`Notify the guest of the incident created`
      case `Notify the user(s) of incident created`:
        return $localize`Notify the user(s) of incident created`
      case `Create a task for new incident`:
        return $localize`Create a task for new incident`
      case `Notify the user(s) of critical incident`:
        return $localize`Notify the user(s) of critical incident`
      case `Set the rental status to Ready when incident resolved`:
        return $localize`Set the rental status to Ready when incident resolved`
      case `Notify the guest of the incident resolved`:
        return $localize`Notify the guest of the incident resolved`
      case `Notify the user(s) of incident resolved`:
        return $localize`Notify the user(s) of incident resolved`
      case `Set follow-up reminder for X hours for incident on hold`:
        return $localize`Set follow-up reminder for X hours for incident on hold`
      case `Notify the user(s) of incident on hold`:
        return $localize`Notify the user(s) of incident on hold`
      case `Notify the user(s) when inventory item created`:
        return $localize`Notify the user(s) when inventory item created`
      case `Notify the user(s) when inventory updated`:
        return $localize`Notify the user(s) when inventory updated`
      case `Notify the user(s) when inventory deleted`:
        return $localize`Notify the user(s) when inventory deleted`
      case `Notify the user(s) when inventory damaged`:
        return $localize`Notify the user(s) when inventory damaged`
      case `Create an incident for inventory damaged`:
        return $localize`Create an incident for inventory damaged`
      case `Notify the user(s) when inventory inoperable`:
        return $localize`Notify the user(s) when inventory inoperable`
      case `Create an incident for inventory inoperable`:
        return $localize`Create an incident for inventory inoperable`
      case `Mark Invoice as Paid when an invoice is created manually`:
        return $localize`Mark Invoice as Paid when an invoice is created manually`
      case `Charge Invoice when an invoice is created manually`:
        return $localize`Charge Invoice when an invoice is created manually`
      case `Send invoice to guest when an invoice is created manually`:
        return $localize`Send invoice to guest when an invoice is created manually`
      case `Send document to sign when invoice created`:
        return $localize`Send document to sign when invoice created`
      case `Send it to Zapier when invoice created`:
        return $localize`Send it to Zapier when invoice created`
      case `Update booking status to paid when an invoice is paid`:
        return $localize`Update booking status to paid when an invoice is paid`
      case `Send payment confirmation to guest when an invoice is paid`:
        return $localize`Send payment confirmation to guest when an invoice is paid`
      case `Send document to sign when invoice is paid`:
        return $localize`Send document to sign when invoice is paid`
      case `Send it to Zapier when invoice paid`:
        return $localize`Send it to Zapier when invoice paid`
      case `Update booking status to unpaid when an invoice is canceled`:
        return $localize`Update booking status to unpaid when an invoice is canceled`
      case `Send it to Zapier when invoice canceled`:
        return $localize`Send it to Zapier when invoice canceled`
      case `Send payment reminder to guest after invoice is overdue`:
        return $localize`Send payment reminder to guest after invoice is overdue`
      case `Notify the user(s) after invoice is overdue`:
        return $localize`Notify the user(s) after invoice is overdue`
      case `Send it to Zapier when invoice is overdue`:
        return $localize`Send it to Zapier when invoice is overdue`
      case `Notify the user(s) when lock connected`:
        return $localize`Notify the user(s) when lock connected`
      case `Send lock code to guest when new is created`:
        return $localize`Send lock code to guest when new is created`
      case `Notify the user(s) when lock code is created`:
        return $localize`Notify the user(s) when lock code is created`
      case `Send updated access code to the guest when it is updated`:
        return $localize`Send updated access code to the guest when it is updated`
      case `Notify the user(s) when lock code is updated`:
        return $localize`Notify the user(s) when lock code is updated`
      case `Notify the user(s) if code is first time used`:
        return $localize`Notify the user(s) if code is first time used`
      case `Notify the user(s) if battery is low`:
        return $localize`Notify the user(s) if battery is low`
      case `Create an incident for low battery`:
        return $localize`Create an incident for low battery`
      case `Notify user(s) to investigate in case of any device issue`:
        return $localize`Notify user(s) to investigate in case of any device issue`
      case `Send a message to the guest when lock has issues`:
        return $localize`Send a message to the guest when lock has issues`
      case `Create an incident for device issues`:
        return $localize`Create an incident for device issues`
      case `Notify user(s) via Email when message received`:
        return $localize`Notify user(s) via Email when message received`
      case `Notify user(s) via Push Notification when message received`:
        return $localize`Notify user(s) via Push Notification when message received`
      case `Notify user(s) via SMS when message received`:
        return $localize`Notify user(s) via SMS when message received`
      case `Send it to Zapier when message received`:
        return $localize`Send it to Zapier when message received`
      case `Notify Guest if review is submitted by Host`:
        return $localize`Notify Guest if review is submitted by Host`
      case `Send it to Zapier when review is submitted by Host`:
        return $localize`Send it to Zapier when review is submitted by Host`
      case `Draft AI based review  when receiving review from guest`:
        return $localize`Draft AI based review  when receiving review from guest`
      case `Send AI based review when receiving review from guest`:
        return $localize`Send AI based review when receiving review from guest`
      default:
        return name
    }
  }
}
